module.exports = {
  signedIn: 'SignedIn',
  miscGCs: 'MISCGCs',
  lastReviewUsername: 'last_review_username',
  productsReviewed: 'products_reviewed',
  shippingCountry: 'shippingCountry',
  currency: 'currency',
  secureUserToken: 'secure_user_token',
  csl: 'CSL', // current store location
  bopsPickupInStore: 'BOPSPICKUPSTORE',
  zipCode: 'USERPC',
  bigTicketZipCode: 'BTZIPCODE',
  forwardPageURL: 'FORWARDPAGE_KEY',
};
